import { t } from 'i18next';
import { addFreeTrialDates } from '@utils';
import { Discount, ProductInventoryStatus, LicenseAgreementInfo } from '@types';
import { InfoNotificationData } from '@components/ProductList/components/InfoNotification';

const FREE_TRIAL = 'FREE_TRIAL';
const LICENSE_AGREEMENT = 'LICENSE_AGREEMENT';

type Params = {
  discount: Discount | undefined;
  isFreeTrial: boolean;
  status: string;
  productLink?: string;
  printOnDemand: boolean;
  licenseAgreementInfo?: LicenseAgreementInfo;
};

export const buildNotificationData = ({
  discount, isFreeTrial, status, productLink, printOnDemand, licenseAgreementInfo,
}: Params): InfoNotificationData | undefined => {
  if (printOnDemand) {
    return {
      title: t('cart.productList.printOnDemand.title'),
      content: [t('cart.productList.printOnDemand.description1'), t('cart.productList.printOnDemand.description2')],
      testId: 'print-on-demand-notification',
    };
  }

  const amount = discount?.freeTrialDuration?.amount;
  const units = discount?.freeTrialDuration?.units;
  const freeTrialDate = addFreeTrialDates(new Date(), amount!, units!);

  let notificationType = isFreeTrial ? FREE_TRIAL : status;
  if (licenseAgreementInfo) {
    notificationType = LICENSE_AGREEMENT;
  }

  const notifications: Record<string, InfoNotificationData> = {
    [FREE_TRIAL]: {
      title: t('cart.productList.terms'),
      content: [
        t('cart.productList.billingStarts'),
        t('cart.productList.cancelBefore', { date: freeTrialDate }),
      ],
      testId: 'free-trial-notification',
    },
    [ProductInventoryStatus.BACK_ORDER]: {
      title: t('cart.productList.outOfStock'),
      content: [
        t('cart.productList.backOrderMessage'),
        t('cart.productList.backOrderMessage2'),
      ],
      testId: 'back-order-notification',
    },
    [ProductInventoryStatus.PRE_ORDER]: {
      title: t('cart.productList.outOfStock'),
      content: [
        t('cart.productList.preOrderMessage'),
        t('cart.productList.preOrderMessage2', {
          productPageLink: `<a href="${productLink}">product page</a>`,
        }),
      ],
      testId: 'pre-order-notification',
    },
    [LICENSE_AGREEMENT]: {
      title: t('cart.productList.licenseAgreement'),
      content: [t('cart.productList.licenseMessage')],
      testId: 'license-notification',
    },
  };

  return notifications[notificationType];
};
